import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import PricingComparison from "./pricing_table";

const AboutCretor: React.FC = () => (
  <div className="creatorabout_page container-fluid first-container ">
    <Helmet title="About Flangoo Creator®" />
    <div className="header text-center mb-5">
      <img
        src="https://flangoo-cdn.s3.us-east-2.amazonaws.com/Just_Released_Ribbon.png"
        alt="Just Released"
        className="img-fluid"
        style={{
          maxWidth: "200px",
          position: "absolute",
          top: "95px",
          left: "0",
          zIndex: "1",
        }}
      />{" "}
      <img
        src="https://flangoo-cdn.s3.us-east-2.amazonaws.com/Flangoo_Creator_WhiteStacked.png"
        alt="Flangoo Creator Logo"
        className="img-fluid"
        style={{ maxWidth: "700px", margin: "50px auto ", display: "block" }}
      />
      <h1 className="text-center mb-5">
        <i>Publish your own writings and stories with Flangoo Creator</i>
      </h1>
      <Link to="/purchaseplan" className="btn btn_lg btn-primary try_btn">
        ADD TO MY SUBSCRIPTION
      </Link>
    </div>
    <div className="row ">
      <div className="col-md-6">
        <h3>
          It’s the Perfect Add-On to Publish Your Works and Gain Access to Other
          Teachers’ Stories
        </h3>
        <p>
          Flangoo Creator includes all the content and all the features of
          Flangoo Library™, and adds several powerful functions.
        </p>
        <h4>Publish</h4>
        <p>
          Publish your own writing and multimedia (audio, images, video, etc.).
          This can be anything you create, anything your students create and
          give you permission to share, and anything that is in the public
          domain.
        </p>
        <h4>Quizzes and Hover-Overs</h4>
        <p>
          Include support materials for the content you publish, such as
          hover-over vocab glosses and comprehension quizzes.
        </p>
        <h4>Share with Your Students and Other Teachers</h4>
        <p>
          Make content you create visible to only your own students or to all
          users. You can publish any given piece of content just for your
          students so that they can easily access it online along with any
          support you’ve added, such as hover-over vocab and comprehension
          quizzes. You can also choose to make anything you’ve created available
          to all other users of Flangoo Creator. This will cause the content
          you’ve shared to appear in the main Flangoo Library (only for other
          users of Flangoo Creator).
        </p>
        <h4>Access to Other Teachers’ Content</h4>
        <p>
          Use content shared by other users of Flangoo Creator. Any content that
          other Flangoo Creator users share will be visible to you. You can
          enjoy it yourself or assign it to your students just like other
          content in the main Flangoo Library.
        </p>
        <h4>Use for Other Languages (Coming in Fall!)</h4>
        <p>
          Create, share, and use content in other languages besides Spanish,
          French, or German. The official content we add to Flangoo Library
          every week is in Spanish, French, and German, but Flangoo Creator
          allows you to add content in any language you choose. This means you
          can use Flangoo Creator as a teacher of Latin, Italian, English, or
          anything else! And, of course, you’ll be able to use content in any
          language that other users of Flangoo Creator share.
        </p>
        {/* <img
          src="https://flangoo-cdn.s3.us-east-2.amazonaws.com/pricing_chart.png"
          className="w-100"
          alt="Flangoo Creator Pricing"
        /> */}
        <PricingComparison />
        <h4>Pricing</h4>
        <div className="pricing_cont">
          <div className="">
            <img
              src="https://flangoo-cdn.s3.us-east-2.amazonaws.com/PricingMonthly.png"
              alt="Flangoo Creator Pricing"
              className="img-fluid"
            />
          </div>
          <div className="">
            <img
              src="https://flangoo-cdn.s3.us-east-2.amazonaws.com/PricingYearly.png"
              alt="Flangoo Creator Pricing"
              className="img-fluid"
            />
          </div>
          <div className="">
            <img
              src="https://flangoo-cdn.s3.us-east-2.amazonaws.com/PricingBundle.png"
              alt="Flangoo Creator Pricing"
              className="img-fluid"
            />
          </div>
        </div>
        <h4>Already have Flangoo Library? </h4>
        <p>
          <Link to={"/purchaseplan"} className="text_underline">
            Add Flangoo Creator
          </Link>{" "}
          to your current subscription for only $49.
        </p>
        <p>
          <small>
            Special pricing available for those whose Flangoo Library
            subscription is expiring soon.{" "}
            <a
              href="mailto:help@teachersdiscovery.com"
              className="text_underline"
            >
              Email us
            </a>
            .
          </small>
        </p>
        <Link
          to="/purchaseplan"
          className="btn btn_lg btn-primary try_btn d-block "
        >
          ADD TO MY SUBSCRIPTION
        </Link>
        <div className="bottom_links">
          <Link to="/support">Get a Guided Tour</Link>
          <Link to="/support">FREE Tech Support</Link>
          <Link to="/fqs">FAQS</Link>
        </div>
      </div>
      <div className="col-md-6 text-center">
        <div className="img_item">
          <img
            src="https://flangoo-cdn.s3.us-east-2.amazonaws.com/EditScreen1.png"
            alt="Flangoo Creator"
            className="img-fluid "
          />
          <p>
            <i>
              Just start typing or import chapters. <br /> Add your own audio
              (optional).
            </i>
          </p>
        </div>
        <div className="img_item">
          <img
            src="https://flangoo-cdn.s3.us-east-2.amazonaws.com/ImageScreen2.png"
            alt="Flangoo Creator 2"
            className="img-fluid "
          />
          <p>
            <i>
              Create and upload your own book cover <br /> and in chapter
              images.
            </i>
          </p>
        </div>
        <div className="img_item">
          <img
            src="https://flangoo-cdn.s3.us-east-2.amazonaws.com/QuizCreatorScreen3.png"
            alt="Flangoo Creator 2"
            className="img-fluid "
          />
          <p>
            <i>
              Add comprehension quizzes (optional) <br />
              and publish your text!
            </i>
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default AboutCretor;
